import { render } from "./MetaWorldViewer.vue?vue&type=template&id=6ee9e602&scoped=true"
import script from "./MetaWorldViewer.js?vue&type=script&lang=js"
export * from "./MetaWorldViewer.js?vue&type=script&lang=js"

import "./MetaWorldViewer.scss?vue&type=style&index=0&id=6ee9e602&lang=scss&scoped=true"

import exportComponent from "C:\\Program Files\\Ampps\\www\\adapter\\metahumen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee9e602"]])

export default __exports__